export const appVersionKey = "__version__";
export const localStorageKey = "__app_storage__";
export const retailersStorageKey = "__retailers__";
export const userSessionStorageKey = "__userid__";
export const currentRetailerStorageKey = "__current_retailer__";
export const brandStorageKey = "__brand__";

export const externalAuthToken = "extTkn";

export const FILTER_NO_RETAILERS = "__all_retailers__";

export const STORE_KEY = "store";
export const PICKUP_ID = "picking_point_id";
export const ADDRESS_KEY = "address";
export const PRODUCTS = "products";
export const FT_EXP_PICKER = "EXPRESS_PICKER";
export const FT_ECO_CARGO = "ECOMMERCE_CARGO";
export const RETAIL_USER_ID_LENGTH = 18;
